webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	/*jshint esversion: 6 */
	__webpack_require__(2);
	
	var settings = __webpack_require__(17);
	var App = __webpack_require__(18);
	
	var web = new App(settings, function (context) {
		web.modal.bindAll(context);
		web.custom.bindAll(context);
	});
	
	$(document).ready(function () {
		var CustomModule = __webpack_require__(21);
		web.custom = new CustomModule(web);
	
		// Modal
		if (web.settings.modal) {
			var WebModal = __webpack_require__(22);
			web.modal = new WebModal(web, web.settings.modal);
		}
	
		web.bindAll();
	});
	
	window.web = web;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// Main styles
	__webpack_require__(3);
	__webpack_require__(5);
	__webpack_require__(6);
	__webpack_require__(7);
	// require('./css/modules/login.css');
	__webpack_require__(8);
	__webpack_require__(9);
	__webpack_require__(10);
	__webpack_require__(11);
	__webpack_require__(12);
	__webpack_require__(13);
	__webpack_require__(14);
	
	__webpack_require__(15);
	__webpack_require__(16);
	
	//Headers
	//require('./css/header/styles.css');
	
	// Custom styles

/***/ },
/* 3 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 4 */,
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 6 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 8 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 9 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 11 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 12 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 13 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 14 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 15 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 16 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports = {
		"useEval": "true",
		"holderId": "#holder",
		"datepicker": {
			"selector": "[role=datepicker]"
		},
		"monthpicker": {
			"selector": "[role=monthpicker]"
		},
		"loader": {
			"selector": "[role=loader-group], .loader",
			"html": "<div role='loader-group'><div class='loader'></div></div>",
			"class": "loader"
		},
		"feedback": {
			"class": "alert",
			"html": "<div></div>",
			"error_class": "error",
			"warning_class": "warning",
			"inprogress_class": "progress",
			"correct_class": "ok"
		},
		"links": {
			"ajax": "[role=ajax]",
			"ajax_no_loader": "[role=ajax-nl]",
			"json": "[role=json]",
			"loop": "[role=loop]",
			"link": "[role=link]"
		},
		"forms": {
			"json": "[role=json-form]",
			"ajax": "[role=ajax-form]",
			"upload": "[role=upload-form]",
			"group": "[role=form-group]",
			"error_class": "has-error",
			"sending_class": "sending",
			"google_captcha": "[role=captcha]",
			"google_captcha_key": "6LfYNCgTAAAAAArFbWWNCAYgmurUkljOQ1KqYMn6"
		},
		"paginator": {
			"selector": "[role=paginator]",
			"content": "[role=page-content]"
		},
		"menu": {
			"selector": "[role=menu]",
			"item": "[role=menu-item]"
		},
		"menu_tab": {
			"selector": "[role=tab-menu]",
			"item": "[role=tab-nav]",
			"tab_new": "[role=tab-new]"
		},
		"dropdown": {
			"selector": "[role=dropdown]",
			"item": "[role=dropdown-item]"
		},
		"input_to_select": {
			"selector": "[role=combo]",
			"separator": "::"
		},
		"login_required": {
			"selector": "[role=doLogin]",
			"template": "/web/sessionExpired"
		},
		"confirm": {
			"selector": "[role=confirm]"
		},
		"activate": {
			"selector": "[role=activate]"
		},
		"delete": {
			"selector": "[role=delete]"
		},
		"toggle": {
			"selector": "[role=toggle-detail]"
		},
		"checkboxgroup": {
			"selector": "[role=checkbox-group]"
		},
		"radiogroup": {
			"selector": "[role=radio-group]"
		},
		"modal": {
			"id": "#modal-window",
			"selectors": {
				"open": "[role=open-modal]",
				"close": "[role=close-modal]"
			},
			"top": "200",
			"closeButton": "<div role='close-modal' class='close-button icon icon-remove c-web-green pointer t-fs26'></div>"
		}
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*jshint esversion: 6 */
	__webpack_require__(19);
	__webpack_require__(20);
	
	var AppCore = function () {
		function AppCore(settings, onBindAll) {
			_classCallCheck(this, AppCore);
	
			this.settings = settings || null;
			this.blocked = false;
			this.popOpts = {
				trigger: "manual",
				html: "true"
			};
	
			this.onBindAll = onBindAll || false;
		}
	
		_createClass(AppCore, [{
			key: 'resetForm',
			value: function resetForm(selector) {
				$(selector).find("input:text, input:password, input:file, select, textarea").val("");
				$(selector).find("input:radio, input:checkbox").removeAttr("checked").removeAttr("selected");
			}
		}, {
			key: 'iniDatePicker',
			value: function iniDatePicker(selector) {
				var self = this;
				$(selector).on("click", function () {
					var that = this;
	
					if ($(this).data("inline")) {
						$(that).parent().append("<i class='datepicker icon icon-calendar'></i>");
					}
	
					var options = {
						format: $(this).data("format") || 'Y-m-d',
						lang: $(this).data("lang") || 'es',
						timepicker: $(this).data("timepicker") || false,
						weeks: $(this).data("weeks") || false,
						inline: $(this).data("inline") || false,
						defaultDate: $(this).data("default") || false,
						defaultTime: $(this).data("default-time") || false,
						dayOfWeekStart: 1,
						closeOnDateSelect: true,
						onGenerate: function onGenerate(ct, $i) {
							if ($(that).data("ongenerate")) self._runFuncByName($(that).data("ongenerate"), window, { "date": ct.dateFormat(options.format), "selector": $(this) });
						},
						onSelectDate: function onSelectDate(ct) {
							if ($(that).data("onselect")) self._runFuncByName($(that).data("onselect"), window, { "date": ct.dateFormat(options.format) });
						},
						onChangeMonth: function onChangeMonth(ct) {
							if ($(that).data("onchangemonth")) self._runFuncByName($(that).data("onchangemonth"), window, { "date": ct.dateFormat(options.format) });
						},
						onChangeYear: function onChangeYear(ct) {
							if ($(that).data("onchangeyear")) self._runFuncByName($(that).data("onchangeyear"), window, { "date": ct.dateFormat(options.format) });
						},
						beforeShowDay: function beforeShowDay(ct) {
							if ($(that).data("beforeshow")) return self._runFuncByName($(that).data("beforeshow"), window, { "date": ct.dateFormat(options.format) });
						},
						onClose: function onClose(ct, $i) {
							if ($("[aria-describedby]").length) {
								$("[aria-describedby]").popover("destroy");
								$("body").unbind("click.popover");
							}
							$i.datetimepicker('destroy');
						}
					};
	
					$(this).datetimepicker(options).datetimepicker('show');
				});
			}
		}, {
			key: 'iniTimePicker',
			value: function iniTimePicker(selector) {
				$(selector).on("click", function () {
					var that = this;
	
					if ($(this).data("inline")) $(that).parent().append("<i class='datepicker icon icon-calendar'></i>");
	
					var options = {
						format: $(this).data("format") || 'H:i',
						lang: $(this).data("lang") || 'es',
						datepicker: false,
						timepicker: true,
						weeks: $(this).data("weeks") || false,
						inline: $(this).data("inline") || false,
						step: 15,
						timepickerScrollbar: true,
						onClose: function onClose(ct, $i) {
							if ($("[aria-describedby]").length) {
								$("[aria-describedby]").popover("destroy");
								$("body").unbind("click.popover");
							}
							$i.datetimepicker('destroy');
						}
					};
	
					$(this).datetimepicker(options);
					$(this).datetimepicker("show");
				});
			}
		}, {
			key: 'iniMonthPicker',
			value: function iniMonthPicker(selector) {
				$(selector).on("click", function () {
					var that = this;
					var options = {
						format: $(this).data("format") || 'Y-m',
						lang: $(this).data("lang") || 'es',
						inline: $(this).data("inline") || false,
						defaultDate: $(this).data("default") || false,
						timepicker: false,
						dayOfWeekStart: 1,
						onGenerate: function onGenerate(ct) {
							$(that).val(ct.dateFormat(options.format));
							// self.custom.datepickerStyles($(this));
							$(this).find('.xdsoft_calendar').hide();
						},
						onChangeMonth: function onChangeMonth(ct) {
							$(that).val(ct.dateFormat(options.format));
						},
						onChangeYear: function onChangeYear(ct) {
							$(that).val(ct.dateFormat(options.format));
						},
						onClose: function onClose(ct, $i) {
							if ($("[aria-describedby]").length) {
								$("[aria-describedby]").popover("destroy");
								$("body").unbind("click.popover");
							}
							$i.datetimepicker('destroy');
						}
					};
	
					$(this).datetimepicker(options);
					$(this).datetimepicker("show");
				});
			}
		}, {
			key: 'ajaxLink',
			value: function ajaxLink(url, target, params, loader, complete, object) {
				var _this = this;
	
				var regexp = new RegExp("'", 'g');
				var settings = {
					url: url.replace(regexp, "") || false,
					target: target ? target.replace(regexp, "") : false,
					params: params || false,
					complete: complete || false,
					loader: loader || false
				};
	
				this.blocked = true;
	
				if (settings.loader !== false) {
					$(object).addClass(this.settings.loader.class);
				}
	
				$.ajax({
					url: settings.url,
					context: document.body,
					data: settings.params,
					success: function success(data, textStatus) {
						if ($("#" + settings.target)) {
							if (data.search('<append>') != -1) {
								$("#" + settings.target).append(data);
							} else {
								$("#" + settings.target).html(data);
							}
							_this.bindAll($("#" + settings.target));
						}
	
						if (settings.complete !== false) {
							if ($.type(settings.complete) == 'function') {
								settings.complete(data);
							} else {
								_this._runFuncByName(settings.complete, window, data);
							}
						}
	
						if (_this.modal && _this.modal.opened) {
							_this.modal.fitContent();
						}
	
						_this.blocked = false;
						$(object).removeClass(_this.settings.loader.class);
					},
					error: function error(xhr, ajaxOptions, thrownError) {
						$(object).removeClass(_this.settings.loader.class);
					}
				});
			}
		}, {
			key: 'jsonLink',
			value: function jsonLink(url, target, params, loader, complete, object) {
				var _this2 = this;
	
				var regexp = new RegExp("'", 'g');
				var settings = {
					url: url.replace(regexp, "") || false,
					target: target ? target.replace(regexp, "") : false,
					params: params || false,
					complete: complete || false,
					loader: loader || false
				};
	
				this.blocked = true;
	
				if (settings.loader !== false) {
					$(object).append(this.settings.loader.html);
				}
	
				$.ajax({
					url: settings.url,
					context: document.body,
					data: settings.params,
					dataType: "json",
					success: function success(data, textStatus) {
						var target = settings.target;
	
						if (target) {
							if ($('#' + target).find("." + _this2.settings.feedback.class).length === 0) $('#' + target).append("<div class='" + _this2.settings.feedback["class"] + "'></div>");
	
							if (data.error) {
								$('#' + target).find("." + _this2.settings.feedback.class).removeClass(_this2.settings.feedback.correct_class).addClass(_this2.settings.feedback.error_class).html(data.msg).fadeIn();
							} else {
								$('#' + target).find("." + _this2.settings.feedback.class).removeClass(_this2.settings.feedback.error_class).addClass(_this2.settings.feedback.correct_class).html(data.msg).fadeIn();
							}
						}
	
						if (settings.complete) {
							if ($.type(settings.complete) == "function") {
								settings.complete(data);
							} else {
								_this2._runFuncByName(settings.complete, window, data);
							}
						}
	
						if (_this2.modal !== undefined && _this2.modal.opened) {
							_this2.modal.fitContent();
						}
	
						_this2.blocked = false;
						$(object).find(_this2.settings.loader.selector).remove();
					},
					error: function error(xhr, ajaxOptions, thrownError) {
						$(object).find(_this2.settings.loader.selector).remove();
					}
				});
			}
		}, {
			key: 'ajaxForm',
			value: function ajaxForm(form, target, params, loader) {
				var _this3 = this;
	
				var regexp = new RegExp("'", 'g');
				var formObj = $("#" + form);
	
				params = params || "";
				loader = loader || false;
				target = target ? target.replace(regexp, "") : false;
	
				if (this.blocked) {
					return false;
				}
	
				this.blocked = true;
	
				if (loader) {
					var submitButton = formObj.find('[type=submit]');
					submitButton.addClass(web.settings.loader.class);
				}
	
				$.ajax({
					url: formObj.attr("action"),
					type: formObj.attr("method"),
					data: formObj.serialize() + params,
					success: function success(data, textStatus) {
						if ($("#" + target)) {
							$("#" + target).html(data);
	
							if (loader) {
								formObj.find(_this3.settings.loader.selector).removeClass(_this3.settings.loader.class);
							}
	
							_this3.bindAll($("#" + target));
						}
	
						_this3.blocked = false;
					},
					error: function error(xhr, ajaxOptions, thrownError) {
						if (loader) {
							formObj.find(_this3.settings.loader.selector).removeClass(_this3.setting.loader.class);
						}
						_this3.blocked = false;
					}
				});
			}
		}, {
			key: 'feedbackMsg',
			value: function feedbackMsg(type, message, target) {
				var obj = target || $("." + this.settings.feedback["class"]);
				switch (type) {
					case "error":
						obj.addClass(this.settings.feedback.error_class);break;
					case "warning":
						obj.addClass(this.settings.feedback.warning_class);break;
					case "progress":
						obj.addClass(this.settings.feedback.inprogress_class);break;
					case "correct":
						obj.addClass(this.settings.feedback.correct_class);break;
				}
				obj.html(message).show();
			}
		}, {
			key: 'inputToSelect',
			value: function inputToSelect(selector) {
				var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
	
				var self = this;
	
				$(selector).each(function () {
					if ($(this).attr("value")) {
						var input = $(this);
						var select = $("<select></select>");
	
						input.replaceWith(select);
						input.removeAttr('role');
	
						$.each(this.attributes, function (i, attrib) {
							var name = attrib.name;
							var value = attrib.value;
	
							if (name === 'value') {
								var values = value.split(sep);
								$.each(values, function (i, val) {
									var opt = val.split("#");
									select.append("<option value='" + opt[0] + "'>" + opt[1] + "</option>");
								});
							} else {
								select.attr(name, value);
							}
						});
	
						if (input.attr("on-create")) {
							self._runFuncByName(input.attr("on-create"), window, select);
						}
	
						if (input.attr("on-change")) {
							select.unbind("change");
							select.on('change', function () {
								self._runFuncByName(input.attr("on-change"), window, select);
							});
						}
	
						if (input.attr("default") !== undefined) {
							select.val(input.attr("default")).change();
						} else {
							select.val(select.children("option:first").val()).change();
						}
					}
				});
			}
		}, {
			key: 'bindAjaxClick',
			value: function bindAjaxClick(selector) {
				var self = this;
	
				$(selector).unbind("click");
				$(selector).on("click", function (e) {
					e.preventDefault();
					self.ajaxLink($(this).attr("href"), $(this).attr("target"), false, $(this).attr('loader'), $(this).attr("after-submit"), this);
				});
			}
		}, {
			key: 'bindJsonClick',
			value: function bindJsonClick(selector) {
				var self = this;
	
				$(selector).unbind("click");
				$(selector).on("click", function (e) {
					e.preventDefault();
					self.jsonLink($(this).attr("href"), $(this).attr("target"), false, $(this).attr('loader'), $(this).attr("after-submit"), this);
				});
			}
		}, {
			key: 'bindRecursiveClick',
			value: function bindRecursiveClick(selector) {
				var self = this;
	
				$(selector).unbind("click");
				$(selector).on("click", function (e) {
					e.preventDefault();
					self.jsonLoop(this);
				});
			}
		}, {
			key: 'jsonLoop',
			value: function jsonLoop(selector) {
				var self = this;
				this.jsonLink($(selector).attr("href"), $(selector).attr("target"), false, $(selector).attr('loader'), function (result) {
					if (result.continue === true) {
						if ($(selector).attr('after-submit')) {
							self._runFuncByName($(selector).attr('after-submit'), window, result);
						}
	
						if (!result.error) {
							self.jsonLoop($(selector));
						}
					} else {
						if ($(selector).attr("on-end")) {
							self._runFuncByName($(selector).attr("on-end"), window, result);
						} else {
							console.log("Loop finished");
						}
					}
				}, selector);
			}
		}, {
			key: 'bindLinkClick',
			value: function bindLinkClick(selector) {
				var self = this;
	
				$(selector).unbind("click");
				$(selector).on("click", function (e) {
					e.preventDefault();
					self.redirect($(this).attr("href"));
				});
			}
		}, {
			key: 'bindAjaxClickNL',
			value: function bindAjaxClickNL(selector) {
				var self = this;
	
				$(selector).unbind("click");
				$(selector).on("click", function (e) {
					e.preventDefault();
					self.ajaxLink($(this).attr("href"), $(this).attr("target"), false, false, $(this).attr("after-submit"), this);
				});
			}
		}, {
			key: 'bindAjaxForm',
			value: function bindAjaxForm(selector) {
				var self = this;
	
				$(selector).each(function () {
					var formObj = $(this);
	
					if (formObj.find("input[name=close]").length === 0) formObj.append("<input type='hidden' name='close' value='0'>");
	
					formObj.find("[type=submit]").each(function () {
						$(this).unbind("click");
						$(this).on("click", function () {
							switch ($(this).attr("role")) {
								case "save":
									formObj.find("input[name=close]").val(0);break;
								case "save&exit":
									formObj.find("input[name=close]").val(1);break;
							}
						});
					});
	
					formObj.ajaxForm({
						beforeSubmit: function beforeSubmit(arr, $form, ops) {
							if (self.blocked) {
								return false;
							}
	
							self.blocked = true;
	
							if (formObj.attr('loader')) {
								formObj.find('[type=submit]').addClass(self.settings.loader.class);
							}
	
							if (formObj.attr("before-submit")) return web._runFuncByName(formObj.attr("before-submit"), window);else formObj.addClass("sending").blur();
						},
						success: function success(data, statusText, xhr, $form) {
							formObj.removeClass("sending");
	
							if (formObj.attr("after-submit")) {
								self.blocked = false;
								self._runFuncByName(formObj.attr("after-submit"), window, data);
							}
	
							$("#" + formObj.attr("target")).html(data);
							self.bindAll($("#" + formObj.attr("target")));
	
							self.blocked = false;
							formObj.find('[type=submit]').delay(0).queue(function () {
								$(this).removeClass(self.settings.loader.class).dequeue();
							});
						},
						error: function error(xhr, ajaxOptions, thrownError) {
							self.blocked = false;
							formObj.removeClass("sending");
							formObj.find('[type=submit]').delay(0).queue(function () {
								$(this).removeClass(self.settings.loader.class).dequeue();
							});
						}
					});
				});
			}
		}, {
			key: 'parseFeedback',
			value: function parseFeedback(jQform, data) {
				var self = this;
	
				if (jQform.data('feedback') === undefined || jQform.data('feedback') === 'all') {
					jQform.find("." + self.settings.feedback["class"]).html(data.msg).removeClass(data.error ? self.settings.feedback.correct_class : self.settings.feedback.error_class).addClass(data.error ? self.settings.feedback.error_class : self.settings.feedback.correct_class).fadeIn();
				} else if (jQform.data('feedback') === 'error') {
					if (data.error) {
						jQform.find("." + self.settings.feedback["class"]).html(data.msg).removeClass(self.settings.feedback.correct_class).addClass(self.settings.feedback.error_class).fadeIn();
					} else {
						jQform.find("." + self.settings.feedback.class).remove();
					}
				} else if (jQform.data('feedback') === 'success') {
					if (!data.error) {
						jQform.find("." + self.settings.feedback["class"]).html(data.msg).removeClass(self.settings.feedback.error_class).addClass(self.settings.feedback.correct_class).fadeIn();
					} else {
						jQform.find("." + self.settings.feedback["class"]).remove();
					}
				}
			}
		}, {
			key: 'bindJsonForm',
			value: function bindJsonForm(selector) {
				var self = this;
	
				$(selector).each(function () {
					var jQform = $(this);
	
					if (jQform.find("input[name=close]").length === 0) jQform.append("<input type='hidden' name='close' value='0'>");
	
					jQform.find("[type=submit]").each(function () {
						$(this).unbind("click");
						$(this).on("click", function () {
							switch ($(this).attr("role")) {
								case "save":
									jQform.find("input[name=close]").val(0);break;
								case "save&exit":
									jQform.find("input[name=close]").val(1);break;
							}
						});
					});
	
					var submitButton = jQform.find('[type=submit]');
	
					jQform.ajaxForm({
						url: jQform.attr("action"),
						type: jQform.attr("method"),
						dataType: "json",
						beforeSubmit: function beforeSubmit(arr, $form, ops) {
							if (self.blocked) return false;
	
							self.blocked = true;
	
							if (jQform.find("." + self.settings.feedback.class).length === 0) jQform.append("<div class='" + self.settings.feedback["class"] + "'></div>");
	
							if (jQform.attr("loader")) {
								submitButton.addClass(self.settings.loader.class);
							}
	
							jQform.find("." + self.settings.forms.error_class).removeClass(self.settings.forms.error_class);
							jQform.find("." + self.settings.feedback["class"]).fadeOut("fast");
	
							if (jQform.attr("before-submit")) {
								return self._runFuncByName(jQform.attr("before-submit"), window);
							} else {
								jQform.addClass(self.settings.forms.sending_class).blur();
							}
						},
						success: function success(data, textStatus) {
							if (data.error) {
								if (jQform.attr("after-error")) {
									self.blocked = false;
									self._runFuncByName(jQform.attr("after-error"), window, data);
								}
	
								if (jQform.data("validator")) {
									jQform.find("[name='" + data.field + "']").closest(self.settings.forms.group).addClass("has-error");
	
									if (data.field) {
										$('html, body').animate({
											scrollTop: jQform.find("[name='" + data.field + "']").closest("input, select").offset().top - 150
										}, 200);
										jQform.find("[name='" + data.field + "']").closest("input, select").focus();
	
										if (jQform.data("tooltip")) {
											self.showToolTip(jQform, data);
										} else {
											self.parseFeedback(jQform, data);
										}
									} else {
										self.parseFeedback(jQform, data);
									}
								} else {
									self.parseFeedback(jQform, data);
								}
	
								if (self.modal && self.modal.opened) {
									self.modal.fitContent();
								}
							} else {
								self.parseFeedback(jQform, data);
	
								if (jQform.attr("after-submit")) {
									self.blocked = false;
									self._runFuncByName(jQform.attr("after-submit"), window, data);
								}
	
								if (data.close == 1) {
									if (self.modal) self.modal.close();
								} else {
									if (self.modal && self.modal.opened) self.modal.fitContent();
								}
							}
	
							submitButton.removeClass(self.settings.loader.class);
	
							self.blocked = false;
						},
						error: function error(xhr, ajaxOptions, thrownError, $form) {
							submitButton.remove();
							self.blocked = false;
						}
					});
				});
			}
		}, {
			key: 'showToolTip',
			value: function showToolTip(jQform, data) {
				var self = this;
				$(".popover").not(jQform.find("[name='" + data.field + "']")).popover('hide');
	
				if (!jQform.find("[name='" + data.field + "']").is("[aria-describedby]")) {
					var popSpecificOpts = {
						trigger: self.popOpts.trigger,
						placement: "top",
						html: self.popOpts.html,
						content: data.msg
					};
	
					jQform.find("[name='" + data.field + "']").popover(popSpecificOpts).show();
					jQform.find("[name='" + data.field + "']").popover('show');
	
					$("body").on("keyup.tooltip", function (event) {
						event.stopPropagation();
						if (!$(event.target).is(".popover-content")) {
							$("[aria-describedby]").popover("destroy");
							$("body").unbind("click.popover");
						}
					});
	
					$("body").on("click.popover", function (event) {
						event.stopPropagation();
						if (!$(event.target).is(".popover-content")) {
							$("[aria-describedby]").popover("destroy");
							$("body").unbind("click.popover");
						}
					});
	
					$("body").unbind("click.tip");
				}
			}
		}, {
			key: 'bindJsonFormSubmit',
			value: function bindJsonFormSubmit(selector) {
				var self = this;
	
				$(selector).unbind("submit");
				$(selector).on("submit", function (e) {
					e.preventDefault();
					self.formJSONSubmit(selector);
				});
			}
		}, {
			key: 'bindUploadForm',
			value: function bindUploadForm(selector) {
				var self = this;
				$(selector).each(function () {
					var form = this;
					var input = $(form).find(":file");
					var uploadButton = $(form).find("[type=button]");
	
					$(form).on("submit", function () {
						if (self.blocked) return false;
	
						self.blocked = true;
	
						var formData = new FormData($(form)[0]);
						var preview = $(form).data("preview") || null;
						var target = $(form).data("target") || null;
	
						if ($(form).find("." + self.settings.feedback.class).length === 0) $(form).append("<div class='" + self.settings.feedbackclass + "'></div>");
	
						$(form).find("." + self.settings.loader.class).fadeIn("fast").show();
						$(form).find("." + self.settings.forms.error_class).removeClass(self.settings.forms.error_class);
						$(form).find("." + self.settings.feedback.class).fadeOut("fast");
	
						if (uploadButton) {
							uploadButton.addClass(self.settings.loader.class);
						}
	
						$.ajax({
							url: $(form).attr("action"),
							type: "post",
							data: formData,
							dataType: 'json',
							cache: false,
							contentType: false,
							processData: false,
							xhr: function xhr() {
								var myXhr = $.ajaxSettings.xhr();
								if (myXhr.upload) myXhr.upload.addEventListener("progress", that.uploadProgress, false);
								return myXhr;
							},
							success: function success(data) {
								if (!data.error) {
									if (data.msg !== false) $(form).find("." + self.settings.feedback.class).html(data.msg).removeClass(self.settings.feedback.error_class).addClass(self.settings.feedback.correct_class).fadeIn();
	
									if (preview) {
										$(preview).css({ "background-image": "url(" + data.data.path + ")" });
									}
	
									if (target) {
										$(target).attr("value", data.data.filename);
									}
	
									if ($(form).attr("after-submit")) {
										self.blocked = false;
										self._runFuncByName($(form).attr("after-submit"), window, data);
									}
								} else {
									$(form).find("." + self.settings.feedback.class).html(data.msg).removeClass(self.settings.feedback.correct_class).addClass(self.settings.feedback.error_class).fadeIn();
									input.val('');
								}
	
								if (uploadButton) {
									$(form).find(self.settings.loader.selector).removeClass(self.settings.loader.class);
								}
	
								self.blocked = false;
							},
							error: function error(xhr, ajaxOptions, thrownError, $form) {
								if (uploadButton) {
									$(form).find(self.settings.loader.selector).removeClass(self.settings.loader.class);
								}
								self.blocked = false;
							}
						});
						return false;
					});
	
					uploadButton.on("click", function () {
						if (self.blocked) return false;
						$(input).trigger("click");
					});
	
					$(input).on("change", function () {
						if (self.blocked) return false;
	
						$(form).submit();
					});
				});
			}
		}, {
			key: 'uploadProgress',
			value: function uploadProgress(p) {
				//console.log(p);
			}
		}, {
			key: 'confirm',
			value: function (_confirm) {
				function confirm(_x) {
					return _confirm.apply(this, arguments);
				}
	
				confirm.toString = function () {
					return _confirm.toString();
				};
	
				return confirm;
			}(function (msg) {
				return confirm(msg);
			})
		}, {
			key: 'loginRequired',
			value: function loginRequired(settings) {
				if (!settings) {
					settings = { transition: "bounce", forcedClose: true };
				}
	
				if (this.modal) {
					this.modal.open(this.settings.login_required.template);
				}
			}
		}, {
			key: 'bindLoginRequired',
			value: function bindLoginRequired(selector) {
				if (this.modal) {
					this.modal.bindOpen(selector, this.settings.login_required.template);
				}
			}
		}, {
			key: 'bindPaginator',
			value: function bindPaginator(selector, pageContainer) {
				var self = this;
				var curpag = parseInt($(selector).find("a.active").attr("pag"));
				var lastpag = parseInt($(selector).find("[name=lastpage]").val());
	
				$(selector).on("click", "a.link", function (e) {
					e.preventDefault();
	
					if (!$(this).hasClass("prev") && !$(this).hasClass("next")) {
						self.ajaxLink($(this).attr("href"), $(this).closest(pageContainer).attr("id"), "ipage=" + $(this).attr("pag"), false, $(this).attr("after-submit"), this);
					} else {
						if ($(this).attr("disabled") != "disabled") {
							self.ajaxLink($(this).attr("href"), $(this).closest(pageContainer).attr("id"), "ipage=" + parseInt(curpag + parseInt($(this).attr("pag"))), false, $(this).attr("after-submit"), this);
						}
					}
				});
	
				$(selector).on("click", "a.form", function (e) {
					e.preventDefault();
	
					if (!$(this).hasClass("prev") && !$(this).hasClass("next")) {
						self.ajaxForm($(this).attr("href"), $(this).parents(pageContainer).attr("id"), "&ipage=" + $(this).attr("pag"), false);
					} else {
						if ($(this).attr("disabled") != "disabled") {
							self.ajaxForm($(this).attr("href"), $(this).parents(pageContainer).attr("id"), "&ipage=" + parseInt(curpag + parseInt($(this).attr("pag"), false)));
						}
					}
				});
	
				if (curpag == 1) {
					$(selector).find("a.prev").addClass("b-grey3").attr("disabled", "disabled").unbind('click');
				}
	
				if (curpag == lastpag) {
					var next = $(selector).find("a.next").addClass("b-grey3").attr("disabled", "disabled");
					next.unbind('click');
				}
			}
		}, {
			key: 'bindMenu',
			value: function bindMenu(menu, option) {
				var self = this;
	
				$(menu).find(option).unbind("click");
				$(menu).each(function () {
					var parentMenu = this;
	
					$(parentMenu).find(option).each(function () {
						$(this).unbind("click");
						$(this).on("click", function (e) {
							e.preventDefault();
							$(parentMenu).find(option).removeClass("active");
							$(this).addClass("active");
	
							var loader = $(this).attr('loader') ? $(this).attr('loader') : $(parentMenu).attr('loader');
	
							if ($(this).attr("href")) {
								var target = $(this).attr("target") || $(parentMenu).attr("target");
	
								self.ajaxLink($(this).attr("href"), target, false, loader, $(this).attr("after-submit"), this);
							} else if ($(this).attr("after-submit")) {
								self.blocked = false;
								self._runFuncByName($(this).attr("after-submit"), window);
							}
						});
					});
				});
			}
		}, {
			key: 'bindOpenTab',
			value: function bindOpenTab(item) {
				var self = this;
				var tabIdPool = [];
	
				$(item).unbind("click");
				$(item).on("click", function () {
					var targetMenu = $(this).attr("target") || false;
	
					if (targetMenu) {
						var newTab = null;
						var newContent = null;
						var curTab = $(targetMenu).find(".active").first();
						var curContent = $("[tab-ref='" + $(curTab).attr("tab-id") + "']");
						var tabId = $(this).attr("tab-id");
	
						if (!tabId) {
							tabId = Math.floor(Math.random() * (9999 - 1000) + 1000);
	
							while (tabIdPool.indexOf(tabId) != -1) {
								tabId = Math.floor(Math.random() * (9999 - 1000) + 1000);
							}
	
							tabIdPool.push(tabId);
							$(this).attr("tab-id", tabId);
						} else {
							if (tabIdPool.indexOf(tabId) == -1) tabIdPool.push(tabId);
						}
	
						if ($(targetMenu).find("[tab-id='" + tabId + "']").length === 0) {
							// Creamos la nueva pestaña
							newTab = $(curTab.first().clone());
	
							newTab.attr({ "tab-id": tabId, "data-href": $(this).data("href") });
							newTab.addClass("active");
							newTab.html($(this).data("tagname"));
							newTab.append("<div role='close-tab'></div>");
	
							if ($(this).data("close-class")) {
								newTab.find("[role='close-tab']").addClass($(this).data("close-class"));
								newTab.find("[role='close-tab']").on("click", function () {
									var prevTab = newTab.prev(self.settings.menu_tab.item);
									newTab.remove();
									$("[tab-ref='" + newTab.attr("tab-id") + "']").remove();
									prevTab.trigger("click");
								});
							}
	
							$(targetMenu).append(newTab);
	
							self.bindMenuTab(targetMenu, self.settings.menu_tab.item);
						} else {
							// La nueva pestaña ya existía
							newTab = $($(targetMenu).find("[tab-id='" + tabId + "']"));
						}
	
						curTab.removeClass("active");
						newTab.addClass("active");
	
						if ($("[tab-ref='" + newTab.attr("tab-id") + "']").length === 0) {
							newContent = curContent.clone();
							newContent.attr({ "id": $(targetMenu).attr("target") + "-" + tabId, "tab-ref": tabId });
							curContent.parent().append(newContent);
	
							if (newTab.data("href")) {
								self.ajaxLink($(this).data("href"), newContent.attr("id"), false, $(this).attr('loader'), false, this);
							}
						} else {
							newContent = $("[tab-ref='" + tabId + "']");
						}
	
						curContent.addClass("hide");
						newContent.removeClass("hide");
					}
				});
	
				$("[role='close-remote-tab']").on("click", function () {
					var targetMenu = $("[tab-id='" + $(this).data('target') + "']").parent(self.settings.menu_tab.selector);
					var prevTab = targetMenu.find(".active").prev(self.settings.menu_tab.item);
					var curTab = targetMenu.find("[tab-id='" + $(this).data('target') + "']");
					if ($(this).data('target')) {
						curTab.remove();
						$("[tab-ref='" + curTab.attr("tab-id") + "']").remove();
						$(prevTab).trigger("click");
					}
				});
			}
		}, {
			key: 'bindMenuTab',
			value: function bindMenuTab(menu, option) {
				var self = this;
	
				$(menu).find(option).unbind("click");
				$(menu).each(function () {
					var parentMenu = this;
					$(parentMenu).find(option).each(function (index) {
						if (!$(this).attr("tab-id")) $(this).attr("tab-id", "tab" + index);
	
						var tabId = $(this).attr("tab-id");
	
						$(this).on("click", function (e) {
							$(parentMenu).find(option).removeClass('active');
							$(this).addClass('active');
	
							if ($(parentMenu).data("refresh")) {
								if ($(this).data("href")) {
									self.ajaxLink($(this).data("href"), tabId, false, $(this).attr('loader'), false, this);
								}
							}
	
							$(parentMenu).parent().find("[tab-ref]").addClass("hide");
	
							var menuItem = $("[tab-ref='" + tabId + "']").find("[role=menu-item].active");
	
							$(parentMenu).parent().find("[role=tab-nav].active").each(function (index) {
								$("[tab-ref='" + $(this).attr("tab-id") + "']").removeClass("hide");
							});
	
							if ($(menuItem).length > 0) {
								self.ajaxLink($(menuItem).attr("href"), $(menuItem).parent("[role=menu]").attr('target'), false, $(this).attr('loader'), false, this);
							}
						});
					});
				});
			}
		}, {
			key: 'bindDropdownMenu',
			value: function bindDropdownMenu(button, list) {
				var self = this;
	
				$(button).unbind("click");
				$(button).on('click', function (e) {
					var element_list = $(this).parent().find(list);
					$(list).not(element_list).removeClass('hide').removeClass('show');
					$(button).find('.icon').not($(this).find('.icon')).removeClass('icon-chevron-up').addClass('icon-chevron-down');
	
					var position = $(this).data('position') || 'bottom';
	
					if (!element_list.hasClass('show') && !element_list.hasClass('hide')) {
						element_list.parent().css('position', 'relative');
						element_list.attr("style", "display:auto; " + position + ":0");
	
						self.actionDropdown(element_list, 'show', $(this).find('.icon'));
					} else if (element_list.hasClass('show')) {
						self.actionDropdown(element_list, 'hide', $(this).find('.icon'));
					} else {
						self.actionDropdown(element_list, 'show', $(this).find('.icon'));
					}
	
					var that = $(this);
					$('body, html').on('click.dropdown', function (event) {
						event.stopPropagation();
						if (element_list.hasClass('show')) {
							if (!$(event.target).is(button)) {
								self.actionDropdown(element_list, 'hide', that.find('.icon'));
								$('body, html').unbind('click.dropdown');
							}
						}
					});
				});
			}
		}, {
			key: 'actionDropdown',
			value: function actionDropdown(element_list, action, icon) {
				if (action === 'show') {
					element_list.removeClass('hide').addClass('show');
				} else if (action === 'hide') {
					element_list.removeClass('show').addClass('hide');
				}
			}
		}, {
			key: 'bindMultipleCheckBox',
			value: function bindMultipleCheckBox(selector, items_check) {
				$(selector).unbind("click");
				$(selector).on("click", function () {
					if ($(this).prop("checked")) {
						$(items_check).prop("checked", true);
					} else {
						$(items_check).prop("checked", false);
					}
				});
			}
		}, {
			key: 'redirect',
			value: function redirect(url) {
				if (url) {
					window.location.href = url;
				}
			}
		}, {
			key: 'errorHandler',
			value: function errorHandler() {
				var _this4 = this;
	
				$(document).unbind("ajaxError");
				$(document).on("ajaxError", function (e, xhr, settings, thrownError) {
					_this4.blocked = false;
	
					if (xhr.status == 412) {
						_this4.loginRequired();
					}
	
					return false;
				});
			}
		}, {
			key: 'bindConfirm',
			value: function bindConfirm(selector) {
				var self = this;
	
				$(selector).unbind("click");
				$(selector).on("click", function (e) {
					e.preventDefault();
					e.stopPropagation();
	
					self.createPopover(this, "confirm");
				});
			}
		}, {
			key: 'bindDeleteClick',
			value: function bindDeleteClick(selector) {
				var self = this;
	
				$(selector).unbind("click");
				$(selector).on("click", function (e) {
					e.preventDefault();
					e.stopPropagation();
	
					self.createPopover(this, "delete");
				});
			}
		}, {
			key: 'bindActivate',
			value: function bindActivate(selector) {
				var self = this;
	
				$(selector).unbind("click");
	
				$(selector).each(function () {
					if ($(this).attr("active") == "1" && $(this).data("active")) {
						if (!$(this).hasClass($(this).data('active'))) {
							$(this).removeClass($(this).data("inactive")).addClass($(this).data("active"));
						}
					} else if ($(this).attr("active") == "0" && $(this).data("inactive")) {
						if (!$(this).hasClass($(this).data('inactive'))) {
							$(this).removeClass($(this).data("active")).addClass($(this).data("inactive"));
						}
					}
				});
	
				$(selector).on("click", function (e) {
					e.preventDefault();
					e.stopPropagation();
					var that = this;
					var message = "";
					if ($(that).data("confirm") && $(this).data("confirm") === true) {
						if ($(that).attr("active") == "1") message = $(that).data("offmsg") || "¿Desactivar el registro?";else if ($(that).attr("active") == "0") message = $(that).data("onmsg") || "¿Activar el registro?";
	
						self.createPopover(that, "confirm", message, function () {
							self.activate(that);
						});
					} else {
						self.activate(that);
					}
				});
			}
		}, {
			key: 'activate',
			value: function activate(obj) {
				var _this5 = this;
	
				if (this.blocked) return false;
	
				this.blocked = true;
	
				var onclass = $(obj).data("active");
				var offclass = $(obj).data("inactive");
				var arrlink = $(obj).attr("href").split("?");
				var active = $(obj).attr("active") || 0;
	
				$.ajax({
					url: arrlink[0],
					data: arrlink[1] ? arrlink[1] + "&active=" + active : "active=" + active,
					type: "post",
					dataType: "json",
					success: function success(res) {
						if (!res.error) {
							$(obj).popover("destroy");
							$(obj).attr("active", res.data.active);
	
							if (res.data.active === 0 && offclass) {
								$(obj).removeClass(onclass).addClass(offclass);
							} else if (res.data.active == 1 && onclass) {
								$(obj).removeClass(offclass).addClass(onclass);
							}
	
							$(obj).attr("active", res.data.active);
	
							if ($(obj).attr("after-submit")) {
								_this5._runFuncByName($(obj).attr("after-submit"), window, res.data);
							}
						}
	
						_this5.blocked = false;
					}
				});
			}
		}, {
			key: 'createPopover',
			value: function createPopover(obj, type, message, callback) {
				var _this6 = this;
	
				var self = this;
				$('.popover').not(obj).popover('hide');
	
				var pos = $(obj).data("position") || "top";
				var msg = "";
	
				if (!$(obj).data("message") && !message) {
					switch (type) {
						case "confirm":
							msg = "¿Confirmar acción?";break;
						case "delete":
							msg = "¿Eliminar registro?";break;
					}
				} else {
					if ($(obj).data("message")) {
						msg = $(obj).data("message");
					} else {
						msg = message;
					}
				}
	
				if (!$(obj).is("[aria-describedby]")) {
					(function () {
						var popSpecificOpts = {
							trigger: _this6.popOpts.trigger,
							placement: pos,
							html: _this6.popOpts.html,
							content: msg
						};
	
						$(obj).popover(popSpecificOpts).show();
						$(obj).popover("show");
	
						$(".popover-content").append('<section role="pop-buttons"></section>');
						$(".popover-content section[role=pop-buttons]").append('<button role="popbut-yes" class="button" type="button">Sí</button><button role="popbut-no" class="button" type="button">No</button>');
	
						var ContentPop = $(obj).attr("aria-describedby");
	
						$('#' + ContentPop).on("click", '[role=popbut-yes]', function (e) {
							var that = this;
							if (self.blocked) return false;
	
							self.blocked = true;
							$(this).addClass(self.settings.loader.class);
	
							if (callback && $.type(callback) == "function") {
								e.stopPropagation();
								self.blocked = false;
								self.bindAll($(obj).parent());
								$(this).removeClass(self.settings.loader.class);
								callback();
							} else {
								$.ajax({
									url: $(obj).attr('href'),
									context: document.body,
									method: 'GET',
									dataType: "json",
									success: function success(data, textStatus) {
										$(that).removeClass(self.settings.loader.class);
	
										if ($('#' + ContentPop).find("." + self.settings.feedback.class).length === 0) $('#' + ContentPop + " .popover-content section").append("<div class='" + self.settings.feedback.class + "'></div>");
	
										if (data.error) {
											$('#' + ContentPop).find("." + self.settings.feedback.class).removeClass(self.settings.feedback.correct_class).addClass(self.settings.feedback.error_class).html(data.msg).fadeIn();
										} else {
											$('#' + ContentPop).find("." + self.settings.feedback.class).removeClass(self.settings.feedback.error_class).addClass(self.settings.feedback.correct_class).html(data.msg).fadeIn();
	
											$('.popover button').remove();
	
											if ($(obj).attr('close-modal') || $(obj).attr("close-modal") == 'true') {
												if (self.modal) {
													self.modal.close();
												}
											}
	
											if (($(obj).attr("remove") || $(obj).attr("remove") !== "") && type == "delete") {
												$($(obj).attr('remove')).remove();
											}
	
											if ($(obj).attr('destroy') && $(obj).attr('destroy') == 'true') {
												$(obj).popover("destroy");
											}
	
											if ($(obj).attr("after-submit")) {
												self.blocked = false;
												self._runFuncByName($(obj).attr("after-submit"), window, data);
											}
										}
	
										self.blocked = false;
										self.bindAll($(obj).parent());
									},
									error: function error(xhr, ajaxOptions, thrownError) {
										self.blocked = false;
										$(that).removeClass(self.settings.loader.class);
									}
								});
							}
						});
	
						$('#' + ContentPop).on("click", "[role=popbut-no]", function (e) {
							e.stopPropagation();
							$(obj).popover("destroy");
						});
					})();
				} else {
					$(obj).popover("destroy");
				}
	
				$('body, html').on('click.popover', function (event) {
					event.stopPropagation();
					var selectors = [];
	
					selectors.push(".popover-content");
					selectors.push(".popover-title");
					if (self.settings.confirm.selector) {
						selectors.push(self.settings.confirm.selector);
					}
	
					if (self.settings.delete.selector) {
						selectors.push(self.settings.delete.selector);
					}
	
					if (self.settings.activate.selector) {
						selectors.push(self.settings.activate.selector);
					}
	
					selectors.push("[role=pop-buttons] button");
	
					if (!$(event.target).is(selectors.join(","))) {
						$("[aria-describedby]").popover("destroy");
						$("body").unbind('click.popover');
					}
				});
			}
		}, {
			key: 'bindToggle',
			value: function bindToggle(selector) {
				var self = this;
				$(selector).unbind("click");
				$(selector).on("click", function (e) {
					e.preventDefault();
	
					var link = $(this).attr("href") || false;
					var target = $(this).attr("target") || false;
	
					if (target) {
						if ($(this).find(".icon").length !== 0) {
							if ($(this).find(".icon").hasClass($(this).data("closed"))) {
								$(this).find(".icon").removeClass($(this).data("closed")).addClass($(this).data("opened"));
								if (link) {
									self.ajaxLink(link, target, false, false, function () {
										$('#' + target).removeClass('collapsed');
									});
								} else {
									$('#' + target).removeClass('collapsed');
								}
							} else {
								$(this).find(".icon").removeClass($(this).data("opened")).addClass($(this).data("closed"));
								$('#' + target).addClass('collapsed');
							}
						} else {
							if ($(this).hasClass($(this).data("closed"))) {
								$(this).removeClass($(this).data("closed")).addClass($(this).data("opened"));
								if (link) {
									self.ajaxLink(link, target, false, false, function () {
										$('#' + target).removeClass('collapsed');
									});
								} else {
									$('#' + target).removeClass('collapsed');
								}
							} else {
								$(this).removeClass($(this).data("opened")).addClass($(this).data("closed"));
								$('#' + target).addClass('collapsed');
							}
						}
					}
				});
			}
		}, {
			key: 'bindInputGroup',
			value: function bindInputGroup(selector, type) {
				var self = this;
				$(selector).each(function () {
					var group = $(this);
					var inputs = group.find('input:' + type);
	
					$(inputs).hide();
	
					$(inputs).each(function () {
						if (group.attr('default') == $(this).val()) {
							$(this).prop('checked', true);
							$(this).parent().addClass('checked');
						} else {
							$(this).prop('checked', false);
							$(this).parent().removeClass('checked');
						}
					});
	
					$(inputs).on('click', function () {
						if (type == 'radio') {
							$(inputs).each(function () {
								$(this).parent().removeClass('checked');
							});
	
							$(this).parent().addClass('checked');
						} else if (type == 'checkbox') {
							if ($(this).prop('checked') === true) {
								$(this).parent().addClass('checked');
							} else {
								$(this).parent().removeClass('checked');
							}
						}
					});
	
					if (group.attr("on-change")) {
						$(inputs).unbind('change');
						$(inputs).on('change', function () {
							self._runFuncByName(group.attr("on-change"), window, $(this));
						});
					}
				});
			}
		}, {
			key: '_runFuncByName',
			value: function _runFuncByName(functionCall, context, extra) {
				var args = void 0;
	
				if (this.settings.useEval == "true") {
					if (extra && functionCall[0] != "$") {
						args = /\b[^()]+\((.*)\).?$/.exec(functionCall);
						if (args && args[1]) {
							functionCall = functionCall.replace(/\(.*\)/, "(" + args[1] + ", extra)");
						} else {
							functionCall = functionCall.replace(/\(.*\)/, "(extra)");
						}
					}
					return eval(functionCall);
				} else {
					args = functionCall.match(/\(([^)]+)\)/);
	
					if (args !== null) {
						args = args[1].split(",");
						args.forEach(function (item, i) {
							args[i] = item.trim();
						});
					} else {
						args = [];
					}
	
					var functionName = functionCall.split("(");
					var namespaces = functionName[0].split(".");
					var func = namespaces.pop();
	
					for (var i = 0; i < namespaces.length; i++) {
						context = context[namespaces[i]];
					}
	
					if (extra) {
						args.push(extra);
					}
	
					if (context[func]) {
						return context[func].apply(context, args);
					} else {
						return false;
					}
				}
			}
		}, {
			key: 'bindCaptcha',
			value: function bindCaptcha(selector, key) {
				var self = this;
	
				if (this.grecaptcha) {
					$.each($(selector), function () {
						self.grecaptcha.render(this, {
							'sitekey': key
						});
					});
				}
			}
		}, {
			key: 'bindAll',
			value: function bindAll(context) {
				context = context || document;
	
				this.errorHandler();
				// Links
				if (this.settings.links) {
					if (this.settings.links.link) {
						this.bindLinkClick($(context).find(this.settings.links.link));
					}
	
					if (this.settings.links.ajax) {
						this.bindAjaxClick($(context).find(this.settings.links.ajax));
					}
	
					if (this.settings.links.json) {
						this.bindJsonClick($(context).find(this.settings.links.json));
					}
	
					if (this.settings.links.ajax_no_loader) {
						this.bindAjaxClickNL($(context).find(this.settings.links.ajax_no_loader));
					}
	
					if (this.settings.links.loop) {
						this.bindRecursiveClick($(context).find(this.settings.links.loop));
					}
				}
	
				// Forms
				if (this.settings.forms) {
					if (this.settings.forms.ajax) {
						this.bindAjaxForm($(context).find("form" + this.settings.forms.ajax));
					}
	
					if (this.settings.forms.json) {
						this.bindJsonForm($(context).find("form" + this.settings.forms.json));
					}
	
					if (this.settings.forms.upload) {
						this.bindUploadForm($(context).find("form" + this.settings.forms.upload));
					}
				}
	
				// Paginator
				if (this.settings.paginator) {
					this.bindPaginator($(context).find(this.settings.paginator.selector), this.settings.paginator.content);
				}
	
				// Login required
				if (this.settings.login_required) {
					this.bindLoginRequired($(context).find(this.settings.login_required.selector));
				}
	
				// Menu
				if (this.settings.menu) {
					this.bindMenu($(context).find(this.settings.menu.selector), this.settings.menu.item);
				}
	
				// Menu-Tab
				if (this.settings.menu_tab) {
					this.bindMenuTab($(context).find(this.settings.menu_tab.selector), this.settings.menu_tab.item);
					this.bindOpenTab($(context).find(this.settings.menu_tab.tab_new));
				}
	
				// DatePicker
				if (this.settings.datepicker) {
					this.iniDatePicker($(context).find(this.settings.datepicker.selector));
				}
	
				// TimePicker
				if (this.settings.timepicker) {
					this.iniTimePicker($(context).find(this.settings.timepicker.selector));
				}
	
				// MonthPicker
				if (this.settings.monthpicker) {
					this.iniMonthPicker($(context).find(this.settings.monthpicker.selector));
				}
	
				// Input to Select
				if (this.settings.input_to_select) {
					this.inputToSelect($(context).find(this.settings.input_to_select.selector), this.settings.input_to_select.separator);
				}
	
				// Dropdown menu
				if (this.settings.dropdown) {
					this.bindDropdownMenu($(context).find(this.settings.dropdown.selector), this.settings.dropdown.item);
				}
	
				// Confirm
				if (this.settings.confirm) {
					this.bindConfirm($(context).find(this.settings.confirm.selector));
				}
	
				// Activate
				if (this.settings.activate) {
					this.bindActivate($(context).find(this.settings.activate.selector));
				}
	
				// Delete
				if (this.settings.delete) {
					this.bindDeleteClick($(context).find(this.settings.delete.selector));
				}
	
				//Toggle
				if (this.settings.toggle) {
					this.bindToggle($(context).find(this.settings.toggle.selector));
				}
	
				// Check buttons group
				if (this.settings.checkboxgroup) {
					this.bindInputGroup($(context).find(this.settings.checkboxgroup.selector), 'checkbox');
				}
	
				// Radio buttons group
				if (this.settings.radiogroup) {
					this.bindInputGroup($(context).find(this.settings.radiogroup.selector), 'radio');
				}
	
				if (this.onBindAll) {
					this.onBindAll(context);
				}
			}
		}]);
	
		return AppCore;
	}();
	
	module.exports = AppCore;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.4
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function Tooltip(element, options) {
	    this.type = null;
	    this.options = null;
	    this.enabled = null;
	    this.timeout = null;
	    this.hoverState = null;
	    this.$element = null;
	
	    this.init('tooltip', element, options);
	  };
	
	  Tooltip.VERSION = '3.3.4';
	
	  Tooltip.TRANSITION_DURATION = 150;
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  };
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled = true;
	    this.type = type;
	    this.$element = $(element);
	    this.options = this.getOptions(options);
	    this.$viewport = this.options.viewport && $(this.options.viewport.selector || this.options.viewport);
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!');
	    }
	
	    var triggers = this.options.trigger.split(' ');
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i];
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
	      } else if (trigger != 'manual') {
	        var eventIn = trigger == 'hover' ? 'mouseenter' : 'focusin';
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout';
	
	        this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
	      }
	    }
	
	    this.options.selector ? this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' }) : this.fixTitle();
	  };
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS;
	  };
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options);
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      };
	    }
	
	    return options;
	  };
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options = {};
	    var defaults = this.getDefaults();
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value;
	    });
	
	    return options;
	  };
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);
	
	    if (self && self.$tip && self.$tip.is(':visible')) {
	      self.hoverState = 'in';
	      return;
	    }
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
	      $(obj.currentTarget).data('bs.' + this.type, self);
	    }
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'in';
	
	    if (!self.options.delay || !self.options.delay.show) return self.show();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show();
	    }, self.options.delay.show);
	  };
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
	      $(obj.currentTarget).data('bs.' + this.type, self);
	    }
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'out';
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide();
	    }, self.options.delay.hide);
	  };
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type);
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e);
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
	      if (e.isDefaultPrevented() || !inDom) return;
	      var that = this;
	
	      var $tip = this.tip();
	
	      var tipId = this.getUID(this.type);
	
	      this.setContent();
	      $tip.attr('id', tipId);
	      this.$element.attr('aria-describedby', tipId);
	
	      if (this.options.animation) $tip.addClass('fade');
	
	      var placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;
	
	      var autoToken = /\s?auto?\s?/i;
	      var autoPlace = autoToken.test(placement);
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top';
	
	      $tip.detach().css({ top: 0, left: 0, display: 'block' }).addClass(placement).data('bs.' + this.type, this);
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
	
	      var pos = this.getPosition();
	      var actualWidth = $tip[0].offsetWidth;
	      var actualHeight = $tip[0].offsetHeight;
	
	      if (autoPlace) {
	        var orgPlacement = placement;
	        var $container = this.options.container ? $(this.options.container) : this.$element.parent();
	        var containerDim = this.getPosition($container);
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > containerDim.bottom ? 'top' : placement == 'top' && pos.top - actualHeight < containerDim.top ? 'bottom' : placement == 'right' && pos.right + actualWidth > containerDim.width ? 'left' : placement == 'left' && pos.left - actualWidth < containerDim.left ? 'right' : placement;
	
	        $tip.removeClass(orgPlacement).addClass(placement);
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);
	
	      this.applyPlacement(calculatedOffset, placement);
	
	      var complete = function complete() {
	        var prevHoverState = that.hoverState;
	        that.$element.trigger('shown.bs.' + that.type);
	        that.hoverState = null;
	
	        if (prevHoverState == 'out') that.leave(that);
	      };
	
	      $.support.transition && this.$tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
	    }
	  };
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip = this.tip();
	    var width = $tip[0].offsetWidth;
	    var height = $tip[0].offsetHeight;
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10);
	    var marginLeft = parseInt($tip.css('margin-left'), 10);
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop)) marginTop = 0;
	    if (isNaN(marginLeft)) marginLeft = 0;
	
	    offset.top = offset.top + marginTop;
	    offset.left = offset.left + marginLeft;
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function using(props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        });
	      }
	    }, offset), 0);
	
	    $tip.addClass('in');
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth = $tip[0].offsetWidth;
	    var actualHeight = $tip[0].offsetHeight;
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight;
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
	
	    if (delta.left) offset.left += delta.left;else offset.top += delta.top;
	
	    var isVertical = /top|bottom/.test(placement);
	    var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';
	
	    $tip.offset(offset);
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
	  };
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow().css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isVertical ? 'top' : 'left', '');
	  };
	
	  Tooltip.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title);
	    $tip.removeClass('fade in top bottom left right');
	  };
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this;
	    var $tip = $(this.$tip);
	    var e = $.Event('hide.bs.' + this.type);
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach();
	      that.$element.removeAttr('aria-describedby').trigger('hidden.bs.' + that.type);
	      callback && callback();
	    }
	
	    this.$element.trigger(e);
	
	    if (e.isDefaultPrevented()) return;
	
	    $tip.removeClass('in');
	
	    $.support.transition && $tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
	
	    this.hoverState = null;
	
	    return this;
	  };
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element;
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
	    }
	  };
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle();
	  };
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element = $element || this.$element;
	
	    var el = $element[0];
	    var isBody = el.tagName == 'BODY';
	
	    var elRect = el.getBoundingClientRect();
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top });
	    }
	    var elOffset = isBody ? { top: 0, left: 0 } : $element.offset();
	    var scroll = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() };
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null;
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset);
	  };
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'top' ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'left' ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	    /* placement == 'right' */{ top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
	  };
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 };
	    if (!this.$viewport) return delta;
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
	    var viewportDimensions = this.getPosition(this.$viewport);
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
	      if (topEdgeOffset < viewportDimensions.top) {
	        // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset;
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
	        // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
	      }
	    } else {
	      var leftEdgeOffset = pos.left - viewportPadding;
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
	      if (leftEdgeOffset < viewportDimensions.left) {
	        // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset;
	      } else if (rightEdgeOffset > viewportDimensions.width) {
	        // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
	      }
	    }
	
	    return delta;
	  };
	
	  Tooltip.prototype.getTitle = function () {
	    var title;
	    var $e = this.$element;
	    var o = this.options;
	
	    title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);
	
	    return title;
	  };
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do {
	      prefix += ~~(Math.random() * 1000000);
	    } while (document.getElementById(prefix));
	    return prefix;
	  };
	
	  Tooltip.prototype.tip = function () {
	    return this.$tip = this.$tip || $(this.options.template);
	  };
	
	  Tooltip.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow');
	  };
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true;
	  };
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false;
	  };
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled;
	  };
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this;
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type);
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions());
	        $(e.currentTarget).data('bs.' + this.type, self);
	      }
	    }
	
	    self.tip().hasClass('in') ? self.leave(self) : self.enter(self);
	  };
	
	  Tooltip.prototype.destroy = function () {
	    var that = this;
	    clearTimeout(this.timeout);
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type);
	    });
	  };
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tooltip');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data && /destroy|hide/.test(option)) return;
	      if (!data) $this.data('bs.tooltip', data = new Tooltip(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.tooltip;
	
	  $.fn.tooltip = Plugin;
	  $.fn.tooltip.Constructor = Tooltip;
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old;
	    return this;
	  };
	}(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.3.4
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function Popover(element, options) {
	    this.init('popover', element, options);
	  };
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js');
	
	  Popover.VERSION = '3.3.4';
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  });
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);
	
	  Popover.prototype.constructor = Popover;
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS;
	  };
	
	  Popover.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	    var content = this.getContent();
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title);
	    $tip.find('.popover-content').children().detach().end()[// we use append for html objects to maintain js events
	    this.options.html ? typeof content == 'string' ? 'html' : 'append' : 'text'](content);
	
	    $tip.removeClass('fade top bottom left right in');
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide();
	  };
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent();
	  };
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element;
	    var o = this.options;
	
	    return $e.attr('data-content') || (typeof o.content == 'function' ? o.content.call($e[0]) : o.content);
	  };
	
	  Popover.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.arrow');
	  };
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.popover');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data && /destroy|hide/.test(option)) return;
	      if (!data) $this.data('bs.popover', data = new Popover(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.popover;
	
	  $.fn.popover = Plugin;
	  $.fn.popover.Constructor = Popover;
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old;
	    return this;
	  };
	}(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* jshint esversion:6*/
	var CustomModule = function () {
		function CustomModule() {
			var AppWeb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
			_classCallCheck(this, CustomModule);
	
			this.AppWeb = AppWeb;
		}
	
		_createClass(CustomModule, [{
			key: 'toggleContact',
			value: function toggleContact() {
				if ($('.mobile-menu').is(':visible')) {
					$('.mobile-menu').css('visibility', 'hidden');
					$('.mobile-menu').css('display', 'none');
				}
				$('#registerSuperBlock').css('visibility', 'visible');
				$('#registerSuperBlock').slideToggle('slow', 'swing');
	
				if ($('.c-hamburger--rot').hasClass("is-active")) {
					$('.c-hamburger--rot').removeClass("is-active");
				} else {
					$('.c-hamburger--rot').addClass('is-active');
				}
			}
		}, {
			key: 'showBlockTags',
			value: function showBlockTags() {
				$("#tabs").tabs();
				$("#tabs2").tabs();
				$("#tabs3").tabs();
			}
		}, {
			key: 'toogleCaptation1',
			value: function toogleCaptation1() {
				$('.consultin1').css('visibility', 'visible');
				$('.consultin1').slideToggle('slow', 'swing');
			}
		}, {
			key: 'toogleCaptation2',
			value: function toogleCaptation2() {
				$('.consultin2').css('visibility', 'visible');
				$('.consultin2').slideToggle('slow', 'swing');
			}
		}, {
			key: 'toogleCaptation3',
			value: function toogleCaptation3() {
				$('.consultin3').css('visibility', 'visible');
				$('.consultin3').slideToggle('slow', 'swing');
			}
		}, {
			key: 'toogleFooter',
			value: function toogleFooter() {
				$('#footer-explain').css('visibility', 'visible');
				$('#footer-explain').slideToggle('slow', 'swing');
			}
		}, {
			key: 'toogleToWhoare',
			value: function toogleToWhoare() {
				$('#footer-explain').css('visibility', 'visible');
				$('#footer-explain').slideToggle('slow', 'swing');
				$('html, body').animate({
					scrollTop: $("#whoarewe").offset().top - 180 }, 'slow');
				$('#whoarewe').focus();
			}
		}, {
			key: 'toogleToWhatwe',
			value: function toogleToWhatwe() {
				$('#footer-explain').css('visibility', 'visible');
				$('#footer-explain').slideToggle('slow', 'swing');
				$('html, body').animate({
					scrollTop: $("#whatwedo").offset().top - 80 }, 'slow');
				$('#whoarewe').focus();
			}
		}, {
			key: 'toogleToHowwe',
			value: function toogleToHowwe() {
				$('#footer-explain').css('visibility', 'visible');
				$('#footer-explain').slideToggle('slow', 'swing');
				$('html, body').animate({
					scrollTop: $("#howwedo").offset().top - 80 }, 'slow');
				$('#whoarewe').focus();
			}
		}, {
			key: 'toogleVision',
			value: function toogleVision() {
				$('#footer-explain-vision').css('visibility', 'visible');
				$('#footer-explain-vision').slideToggle('slow', 'swing');
	
				$('html, body').animate({
					scrollTop: $("#footer-explain-vision").offset().top - 80 }, 'slow');
				$('#footer-explain-vision').focus();
			}
		}, {
			key: 'closeFooter',
			value: function closeFooter() {
				$('#footer-explain').slideUp('slow', 'swing');
			}
		}, {
			key: 'closeVision',
			value: function closeVision() {
				$('#footer-explain-vision').slideUp('slow', 'swing');
			}
		}, {
			key: 'closeContact',
			value: function closeContact() {
				$('#footer-contact').slideUp('slow', 'swing');
	
				/*
	   		if() {
	   
	   		}
	   		*/
	
				if ($('.c-hamburger--rot').hasClass("is-active")) {
					$('.c-hamburger--rot').removeClass("is-active");
					console.log("Remove");
				} else {
					$('.c-hamburger--rot').addClass('is-active');
					console.log("Inactive	");
				}
			}
		}, {
			key: 'toogleContact2',
			value: function toogleContact2() {
				$('#footer-contact').css('visibility', 'visible');
				$('#footer-contact').slideToggle('slow', 'swing');
	
				if ($('.mobile-menu').is(':visible')) {
					$('.mobile-menu').css('visibility', 'hidden');
					$('.mobile-menu').css('display', 'none');
				} else {
					$('.mobile-menu').css('visibility', 'visible');
					$('.mobile-menu').css('display', 'inline-block');
				}
				$("html, body").animate({
					scrollTop: $("#footer-contact").offset().top - 80 }, 'slow');
				$('#footer-contact').focus();
			}
		}, {
			key: 'showMyMenu',
			value: function showMyMenu() {
				if ($('#footer-contact').css('display') == 'inline-block') {
					$('#footer-contact').css('display', 'none');
					$('#footer-contact').css('visibility', 'hidden');
	
					if ($('.c-hamburger--rot').hasClass("is-active")) {
						$('.c-hamburger--rot').removeClass("is-active");
					} else {
						$('.c-hamburger--rot').addClass('is-active');
					}
	
					console.log("Displaying in block");
				} else {
					$('#footer-contact').css('visibility', 'visible');
					$('#footer-contact').slideToggle('slow', 'swing');
	
					if ($('.c-hamburger--rot').hasClass("is-active")) {
						$('.c-hamburger--rot').removeClass("is-active");
					} else {
						$('.c-hamburger--rot').addClass('is-active');
					}
				}
			}
		}, {
			key: 'check_captcha',
			value: function check_captcha() {
				var v = grecaptcha.getResponse();
				if (v.length == 0) {
					document.getElementById('captcha').innerHTML = "You can't leave Captcha Code empty";
					return false;
				}
			}
		}, {
			key: 'bindAll',
			value: function bindAll(context) {
				$('#web-message [role=close]').on('click', function () {
					$('#web-message').remove();
				});
	
				web.custom.showBlockTags();
			}
		}]);
	
		return CustomModule;
	}();
	
	module.exports = CustomModule;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/*jshint esversion: 6 */
	__webpack_require__(18);
	
	var WebModal = exports.WebModal = function () {
		function WebModal() {
			var AppWeb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			_classCallCheck(this, WebModal);
	
			this.AppWeb = AppWeb;
			this.opened = false;
			this.settings = settings;
			this.size = {
				width: 0,
				height: 0
			};
			this.config = {
				width: 0,
				height: 0
			};
			this.customSettings = {};
		}
	
		_createClass(WebModal, [{
			key: "open",
			value: function open(url) {
				var that = this;
				var _modal = $(this.settings.id);
	
				_modal.css({ height: $(window).height(), top: $(document).scrollTop() });
	
				var content = _modal.find(".modal-content");
				content.css({ top: parseInt(that.settings.top) });
	
				_modal.fadeIn("fast");
	
				_modal.find(".modal-content").load(url, function () {
					if (that.AppWeb.blocked) return false;
	
					that.AppWeb.blocked = true;
	
					var inner_content = content.find("[role=modal-main]");
	
					if (inner_content.length === 0) {
						content.html("<section role='modal-main'>" + content.html() + "</section>");
						inner_content = content.find("[role=modal-main]");
					}
	
					that.config.width = inner_content.data("width") !== undefined ? inner_content.data("width") : "auto";
					that.config.height = inner_content.data("height") !== undefined ? inner_content.data("height") : "auto";
	
					if (that.settings.closeButton) {
						content.append(that.settings.closeButton);
					}
	
					inner_content.width(that.config.width);
					inner_content.height(that.config.height);
	
					$('html').css({ 'overflow-y': 'hidden' });
					that.opened = true;
					that.size.width = inner_content.outerWidth();
					that.size.height = inner_content.outerHeight();
	
					/* Events */
					$(window).on("resize.modal", function () {
						that.resize(that);
					});
					$(window).on("keydown.modal", function (e) {
						if (e.which == 27) that.close();
					});
	
					_modal.unbind("click");
					_modal.on("click", function (e) {
						that.close();
					});
	
					content.on("click", function (e) {
						e.stopPropagation();
					});
	
					that.bindClose(that.settings.selectors.close);
					that.fitContent();
	
					if (that.customSettings.onComplete) {
						if ($.type(that.customSettings.onComplete) == "function") {
							that.customSettings.onComplete();
						} else {
							that._runFuncByName(that.customSettings.onComplete, window);
						}
					}
	
					that.AppWeb.blocked = false;
					that.AppWeb.bindAll(_modal);
	
					$(inner_content).find('input:first').focus();
				});
			}
		}, {
			key: "calculate",
			value: function calculate(inner_content) {
				var that = this;
				var dim = { width: "auto", height: "auto" };
	
				// Width
				if (inner_content.outerWidth() > $(window).width()) {
					dim.width = $(window).width() - 20;
				} else {
					if ($(window).width() >= inner_content.outerWidth()) {
						if (that.size.width > $(window).width()) {
							dim.width = $(window).width() - 20;
						} else {
							if (that.config.width !== "auto") dim.width = that.size.width - 20;
						}
					}
				}
				return dim;
			}
		}, {
			key: "fitContent",
			value: function fitContent() {
				if (this.opened) {
					this.resize(this);
				}
			}
		}, {
			key: "resize",
			value: function resize(modal) {
				var that = this;
				var _modal = $(that.settings.id);
				var content = _modal.find(".modal-content");
				var inner_content = content.find("[role=modal-main]");
				var _top = 0;
	
				_top += that.settings.top !== undefined ? parseInt(that.settings.top) : 0;
				var dim = that.calculate(inner_content);
	
				_modal.css({ height: $(window).height(), top: $(document).scrollTop() });
				$(content).css({ top: _top });
	
				$(content).css({ width: dim.width, height: dim.height });
				$(inner_content).css({ width: dim.width, height: dim.height });
			}
		}, {
			key: "bindOpen",
			value: function bindOpen(selector, url) {
				var that = this;
	
				$(selector).unbind("click");
				$(selector).on("click", function (e) {
					e.preventDefault();
					that.customSettings = {
						closeButton: $(this).data("closebut"),
						loader: $(this).attr('loader') || false,
						transition: $(this).data("transition") || null,
						onComplete: $(this).attr("on-complete") || null,
						onClose: $(this).attr("on-close") || null
					};
	
					if (that.AppWeb.settings.loader) {
						$(this).append(that.AppWeb.settings.loader.html);
					}
	
					that.open(url !== undefined ? url : $(this).attr("href"), $(this));
				});
			}
		}, {
			key: "close",
			value: function close() {
				$(window).off("resize.modal");
				$(window).off("scroll.modal");
				$(window).off("keydown.modal");
	
				$(this.settings.id).fadeOut("fast");
				$(this.settings.id).find(".modal-content").html("");
	
				$('html').css({ 'overflow-y': '' });
	
				if (this.customSettings.onClose) {
					if ($.type(this.customSettings.onClose) == "function") {
						this.customSettings.onClose();
					} else {
						this.AppWeb._runFuncByName(this.customSettings.onClose, window);
					}
				}
				this.opened = false;
				this.customSettings = {};
			}
		}, {
			key: "bindClose",
			value: function bindClose(selector) {
				var _this = this;
	
				$(selector).unbind("click");
				$(selector).on("click", function () {
					_this.close();
				});
			}
		}, {
			key: "bindAll",
			value: function bindAll(context) {
				this.bindOpen($(context).find(this.settings.selectors.open));
			}
		}]);
	
		return WebModal;
	}();
	
	module.exports = WebModal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }
]);


// WEBPACK FOOTER //
// dist/app.bundle.js